import { getOwnInfo, login, deleteMember, updateLogin } from '@/api/user';
import { getMatchmakerInfo } from '@/api/matchmakerInfo';
import { getToken, setToken, removeToken, removeOaInfo } from '@/utils/auth'
import jwt_decode from 'jwt-decode';

const user = {
  state: { 
    token: getToken(),  // token
    baseInfo: {}, //  用户基本数据(非会员没有)
    role: '', //  用户角色  Matchmaker 红娘    Member 会员    GeneralUser 非会员
    infoList: [], // 会员信息列表
    followInfoList: [], // 跟进信息列表
    reocrdList: [], // 浏览记录数据
    nextRole: '', // 申请的角色（还未通过审核)
    getBaseInfo: false, // 是否获取过基本信息
    queryListName: 'query', // 从哪个页面进来详情页
    activityBack: false, // 是否活动页返回
    queryPage: {  //  三个分页查询。
      page: 1,
      sex: '',
      education: '',
      minimumBirthday: '',
      maximumBirthday: '',
      minimumHeight: '',
      maximumHeight: '',
      serialNumber: '',
      maximumBirthday: '',
      hometown: '',
      areaNum: 1,
    },
    checkPage: {
      page: 1,
    },
    followPage: {
      page: 1,
    }
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INFOS: (state, baseInfo) => {
      state.baseInfo = baseInfo
    },
    SET_ROLES: (state, role) => {
      state.role = role
    },
    SET_INFOLIST: (state, infoList) => {
      state.infoList = infoList
    },
    SET_ReocrdLIST: (state, infoList) => {
      state.reocrdList = infoList
    },
    SET_FOLLOWINFOLIST: (state, followInfoList) => {
      state.followInfoList = followInfoList
    },
    SET_NEXTROLE: (state, nextRole) => {
      state.nextRole = nextRole
    },
    SET_GETBASEINFO: (state, isGet) => {
      state.getBaseInfo = isGet
    },
    SET_QUERYLISTNAME: (state, queryListName) => {
      state.queryListName = queryListName
    },
    SET_PAGE: (state, params) => {
      state[params.name] = {
        ...state[params.name],
        page: params.page
      }
    },
    SET_QUERYList:(state, params) => {
      // params.page = state.queryPage.page;
      const query = {...state.queryPage,...params};
      state.queryPage = query
    },
    SET_ACTIVITY: (state, isActivityBack) => {
      state.activityBack = isActivityBack
    },
  },

  actions: {

    // 获取用户信息
    GetInfo({ commit, state },isLogin=false) {
      return new Promise((resolve, reject) => {
          const userId = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier';
          const roleKey = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
          let id, role, nextRole;
          try {
            const jwtDecodeVal = jwt_decode(getToken());
            id = jwtDecodeVal[userId];
            role = jwtDecodeVal[roleKey];
            nextRole = jwtDecodeVal.nextRole;
          } catch (e) {
            // token解析失败，清除状态
            commit('SET_TOKEN', '')
            commit('SET_ROLES', '')
            removeToken();
            reject(e);
            return;
          }
          commit('SET_NEXTROLE',nextRole);
          commit('SET_ROLES', role)
          // 第一次登录进来，或者已经刷新过token，此时的token是最新的，则不需要刷新token
          if (!isLogin) {
            // 如果是登录进来或者已经进来过则不调用此时判断
            // 其他情况下进来，先获取刷新接口，如果改变了就设置新的token，然后重新调用此方法
            // 并且不进入此判断
            // 如果没有改变也是执行此方法，但是不设置新的token
            updateLogin().then(res => {
              if (res.code === 20000) {
                if (res.data.isRoleChange) {
                  //  已经是其他的状态
                  // commit('SET_TOKEN', )
                  this.dispatch('SetToken',res.data.token).then(() => {
                    this.dispatch('GetInfo',true).then(() => {
                      resolve();
                    }).catch(()=>{
                      reject();
                    })
                  })
                } else {
                  if (res.data.token) {
                    this.dispatch('SetToken',res.data.token).then(() => {
                      this.dispatch('GetInfo',true).then(() => {
                        resolve();
                      }).catch(()=>{
                        reject();
                      })
                    })
                  } else {
                    this.dispatch('GetInfo',true).then(() => {
                      resolve();
                    }).catch(()=>{
                      reject();
                    })
                  }
                }
              } else {
                this.dispatch('SetToken','');
                removeToken();
                reject();
              }
            }).catch(() => {
                this.dispatch('SetToken','');
                removeToken();
                reject();
            })
            return;
          }
          if (id) {
            if (role === 'Member') {
              // 会员角色调会员查询接口
              getOwnInfo(id).then(res => {
                if (res.data) { 
                    commit('SET_GETBASEINFO', true)
                    commit('SET_INFOS', res.data)
                    resolve(res)
                }
              }).catch(error => {
                reject(error)
              })
            } else if(role === 'Matchmaker') {
              // 红娘角色调红娘查询接口
              const params = {id: id}
              getMatchmakerInfo(params).then(res => {
                if (res.data) { 
                    commit('SET_GETBASEINFO', true)
                    commit('SET_INFOS', res.data)
                    resolve(res)
                }
              }).catch(error => {
                reject(error)
              })
            }  else{
              commit('SET_GETBASEINFO', true)
              resolve()
            //   // 非会员，登录成功，调用jie 
            //   updateLogin().then(res => {
            //     if (res.code === 20000) {
            //       if (res.data.isRoleChange) {
            //         //  已经是其他的状态
            //         // commit('SET_TOKEN', )
            //         this.dispatch('SetToken',res.data.token).then(() => {
            //           this.dispatch('GetInfo',true).then(() => {
            //             resolve();
            //           }).catch(()=>{
            //             reject();
            //           })
            //         })
            //       } else {
            //         // 请求，如果角色未改变，直接返回出去
            //         resolve();
            //       }
            //     } else {
            //       reject();
            //     }
            //   })
            }
          } else {
            commit('SET_GETBASEINFO', true)
            resolve()
          }          
      })
    },
    // 更新用户基本数据
    UpdateBasicInfo({commit}, data) {
      return new Promise((resolve, reject) => {
        // getOwnInfo(state.token).then(res => {
          // 暂时没有登录，token 先写死
          commit('SET_INFOS', data);
          resolve();
      })
    },

    SetToken({commit},token) {
      return new Promise((resolve, reject) => {
        setToken(token)
        commit('SET_TOKEN', token)
        resolve()
      })
    },

    // 登录
    Login({ commit }, userInfo) {
      const phoneNumber = userInfo.phoneNumber.trim();
      const verificationCode = userInfo.verificationCode;
      const params = {
        phoneNumber,
        verificationCode
      }
      // 如果有微信openid，一并传递用于绑定
      if (userInfo.openId) {
        params.openId = userInfo.openId;
      }
      return new Promise((resolve, reject) => {
        login(params).then(res => {
          if (res.code === 20000) {
            setToken(res.data.token)
            commit('SET_TOKEN', res.data.token)
            this.dispatch('GetInfo',true).then(() => {
              resolve()
            }).catch(()=>{
            })
          } else {
            reject(res.msg);
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    DeleteMember({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        deleteMember(params).then((res) => {
          // 响应拦截器返回 res.data，即 { code, msg, data: "jwt-string" }
          // 需要取 res.data 才是真正的 JWT token 字符串
          const token = res && res.data ? res.data : null;
          if (token) {
            // 内部人员退会：切换为普通用户身份，保留token
            setToken(token)
            commit('SET_TOKEN', token)
            // 从新token中解析实际角色，避免硬编码与JWT不一致
            const roleKey = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';
            let role = 'GeneralUser';
            try {
              const jwtDecodeVal = jwt_decode(token);
              role = jwtDecodeVal[roleKey] || 'GeneralUser';
            } catch (e) {
              // token解析失败时回退为GeneralUser
            }
            commit('SET_ROLES', role)
            commit('SET_INFOS', {})
          } else {
            // 外部人员退会：清除所有状态，跳转到登录
            commit('SET_TOKEN', '')
            commit('SET_INFOS', {})
            commit('SET_ROLES', '')
            commit('SET_GETBASEINFO', false)
            commit('SET_INFOLIST', [])
            commit('SET_ReocrdLIST', [])
            commit('SET_FOLLOWINFOLIST', [])
            removeToken()
            removeOaInfo()
          }
          resolve(token)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SET_Activity({commit}, isActivity) {
      commit('SET_ACTIVITY', isActivity)
    },
    SET_QueryList({ commit }, params) {
      commit('SET_QUERYList', params);
    },
    SET_Page({ commit }, params) {
      commit('SET_PAGE', params);
    },
    SetQueryName({ commit }, name) {
      commit('SET_QUERYLISTNAME', name);
    },
    SetInfoList({ commit }, infoList) {
      commit('SET_INFOLIST', infoList);
    },
    SetReocrdList({ commit }, infoList) {
      commit('SET_ReocrdLIST', infoList);
    },
    SetFollowInfoList({ commit }, infoList) {
      commit('SET_FOLLOWINFOLIST', infoList);
    },
    SET_ROLES({ commit }, role) {
      commit('SET_ROLES', role);
    },
    RemoveToken({ commit, state }) {
      return new Promise((resolve, reject) => {
          commit('SET_TOKEN', '')
          commit('SET_INFOS', {})
          commit('SET_ROLES', '')
          commit('SET_INFOLIST', [])
          commit('SET_ReocrdLIST', [])
          commit('SET_FOLLOWINFOLIST', [])
          removeToken()
          removeOaInfo()
          resolve()
      })
    } 
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js